import { request, API_V1_PREFIX } from "./client";
import type { ActivityGradeData } from "./types";

export async function getGrades(token: string, activityId?: string, studentId?: string): Promise<ActivityGradeData[]> {
  const params = new URLSearchParams();
  if (activityId) params.append("activity_id", activityId);
  if (studentId) params.append("student_id", studentId);

  const queryString = params.toString() ? `?${params.toString()}` : "";
  return request<ActivityGradeData[]>(`${API_V1_PREFIX}/activity-grades${queryString}`, { method: "GET" }, { token });
}

export async function saveGrade(
  data: Omit<ActivityGradeData, "id">,
  token: string,
): Promise<ActivityGradeData> {
  return request<ActivityGradeData>(
    `${API_V1_PREFIX}/activity-grades`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function updateGrade(id: string, data: Partial<ActivityGradeData>, token: string): Promise<ActivityGradeData> {
  return request<ActivityGradeData>(
    `${API_V1_PREFIX}/activity-grades/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token }
  );
}
